var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5094 6.5625V2.8125H19.6969V6.5625H10.3031V2.8125H7.5V6.5625H2.8125V27.1875H27.1875V6.5625H22.5094ZM25.3125 25.3125H4.6875V11.25H25.3125V25.3125ZM19.8187 13.8187L20.0531 14.2125C18.2531 15.8438 16.2656 18.2812 15.2156 20.3625C14.9812 20.8219 14.7 21.525 14.4187 22.275L12.9 22.2844C12.6469 21.6281 12.3563 21.0375 12.0469 20.5406C11.3344 19.3875 10.4625 18.5906 9.83437 18.1125L10.0125 17.7C11.6344 17.9156 12.3563 18.3188 13.2563 19.0219C14.3531 17.5219 16.2281 15.1406 19.8187 13.8187Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditsIcon);
export default __webpack_public_path__ + "static/media/Audits-icon.07861d2defa3966eedd6c3a87f0bd97f.svg";
export { ForwardRef as ReactComponent };